import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import BackArrow from '../../assets/images/Frame_18177.png';
import { useDispatch } from 'react-redux';
import { login } from "../../actions/authActions";
import InactivityTimer from '../../components/InactivityTimer';

const VerifyOTP = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const mobileNumber = location?.state?.inputValue || '';

    const [inputValue, setInputValue] = useState(['', '', '', '', '', '']);
    const [error, setError] = useState('');
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (!mobileNumber) {
            navigate('/'); // if no mobile number, redirect back
        }
    }, [mobileNumber, navigate]);

    useEffect(() => {
        if (seconds > 0) {
            const timer = setInterval(() => {
                setSeconds(prev => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else {
            setIsResendEnabled(true);
        }
    }, [seconds]);

    const handleChange = (event, index) => {
        const { value } = event.target;
        if (/[^0-9]/.test(value)) return; // allow only numbers

        const newInput = [...inputValue];
        newInput[index] = value;
        setInputValue(newInput);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        } else if (!value && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }

        setError('');
    };

    const handleResendOTP = async () => {
        try {
            await axiosInstance.post(`patient/loginreq?input=${mobileNumber}`);
            setSeconds(60);
            setIsResendEnabled(false);
            setError('');
        } catch (err) {
            setError('Failed to resend OTP.');
        }
    };

    const validateOTP = async () => {
        const otp = inputValue.join('');
        if (otp.length !== 6) {
            setError('Please enter the complete 6-digit OTP.');
            return;
        }

        try {
            const token = await authenticateUser(mobileNumber, otp);
            dispatch(login(token));
            navigate("/dashboard", { replace: true });

            // const response = await axiosInstance.post(`patient/loginverify?input=${mobileNumber}&otp=${otp}`);

            // if (response.status === 200) {
            //     setError('');
            //     navigate('/dashboard');
            // } else {
            //     setError('Invalid OTP. Please try again.');
            // }
        } catch (err) {
            setError('Invalid OTP. Please try again.');
        }
    };

    const authenticateUser = async (mobileNumber, otp) => {
        try {
            const response = await axiosInstance.post(`patient/loginverify?input=${mobileNumber}&otp=${otp}`);
            return response.data.tokenNo;
        } catch (error) {
            if (error.response) {
                setError(error.response.data.error);
            } else {
                setError("Unexpected error. Please try again.");
            }
            throw new Error("Authentication failed");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateOTP();
    };

    return (
        <div>
            <InactivityTimer />
            <div className='flex inline-block'>
                <Link to="/" className="flex w-28 mt-6 ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}>
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>
                    Already Registered
                </span>
            </div>

            <hr className="mt-6 ml-14 mr-14 border-t-1 border-gray-300" />

            <div className="flex justify-center mt-10 mb-10">
                <div className="bg-[#42424A] shadow-lg rounded-lg p-6 flex flex-col items-center w-full max-w-sm">
                    <form className="w-full" onSubmit={handleSubmit}>
                        <div className="relative mb-4 mt-6">
                            <label className="block text-white mb-2" htmlFor="otp" style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500', lineHeight: '18px' }}>
                                Enter OTP
                            </label>
                            <div className="flex justify-between items-center mb-4">
                                <span className='text-white' style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400', lineHeight: '18px' }}>
                                    An OTP has been sent to {mobileNumber.slice(-4).padStart(mobileNumber.length, 'x')}
                                </span>
                                {seconds > 0 && (
                                    <span className='text-[#1ACD81]' style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400', lineHeight: '18px' }}>
                                        {seconds} sec
                                    </span>
                                )}
                            </div>

                            <div className="flex flex-col">
                                <div className="flex space-x-2">
                                    {inputValue.map((value, index) => (
                                        <div key={index} className="relative">
                                            <input
                                                type="text"
                                                maxLength="1"
                                                ref={el => inputRefs.current[index] = el}
                                                value={value}
                                                onChange={(e) => handleChange(e, index)}
                                                className={`bg-[#EFFEF7] border ${error ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-lg rounded-lg block w-full h-12 text-center focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent`}
                                            />
                                        </div>
                                    ))}
                                </div>
                                {error && (
                                    <p className="text-red-500 text-md mt-1">{error}</p>
                                )}
                            </div>

                            <div className="flex justify-between items-center mb-2 mt-4">
                                <button
                                    type="button"
                                    className={`text-[#1ACD81] w-36 ${isResendEnabled ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                    style={{ fontFamily: 'Roboto', fontSize: '16px', fontWeight: '400', lineHeight: '18px' }}
                                    onClick={handleResendOTP}
                                    disabled={!isResendEnabled}
                                >
                                    Resend OTP
                                </button>
                                <button
                                    type="submit"
                                    className='bg-[#1ACD81] text-white w-full py-2 rounded-lg'
                                    style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500', lineHeight: '18px' }}
                                >
                                    VERIFY
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default VerifyOTP;
